module.exports = __webpack_public_path__ + "static/virtual_printer-9be4b0607382b7159be12561c9d00ffd.jpg";